<template>
	<section id="intro" class="main-content intro">
		<div class="row">
			<slot name="content">
				<div :class="!introductionContent.length ? 'column12 align-center ' : 'column6'">
					<div class="title-reverse-wrapper">
						<h2 v-if="subtitle" class="subtitle" :class="!subtitle.length && 'no-after'">
							{{ subtitle }}
						</h2>
					</div>
				</div>
				<div class="fullwidth-row flex">
					<div :class="!introductionContent.length ? 'column12 align-center ' : 'column6'">
						<div class="title-reverse-wrapper">
							<h1>{{ title }}</h1>
						</div>
					</div>
					<div v-if="introductionContent.length" class="columns column5">
						<div v-parse-links v-html="introductionContent" />
						<slot name="extra-content" />
					</div>
				</div>
			</slot>
		</div>
		<slot name="bgImage">
			<div />
		</slot>
	</section>
	<section v-if="content.length" class="main-content background-light">
		<div class="row flex justify-center">
			<div class="columns column8">
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</section>
	<slot />
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	introductionContent: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.align-center {
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.justify-center {
	justify-content: center;
}

@media (max-width: 920px) {
	.columns {
		flex: 1 0 100%;
		max-width: 100%;
	}

	.fullwidth-row {
		flex-wrap: wrap;
	}
}
</style>
